module.exports = __webpack_public_path__ + "img/nr.7b40d2a3.svg";